import { DateTimeString, getDateTimeString } from "../../dateTypes.js";
import { CellExecutionState } from "../../enums.js";
import { AppSessionCellId, CellId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CREATE_APP_SESSION_CELL = createAppSessionEventDefinition({
  type: "CREATE_APP_SESSION_CELL",
  logSafe: {
    cellId: true,
    appSessionCellId: true,
    state: true,
    lastExecutionEndTime: true,
    lastExecutionStartTime: true,
  },
  create: ({
    lastExecutionEndTime,
    lastExecutionStartTime,
    ...rest
  }: {
    appSessionCellId: AppSessionCellId;
    cellId: CellId;
    state?: CellExecutionState;
    lastExecutionEndTime?: Date | DateTimeString | null;
    lastExecutionStartTime?: Date | DateTimeString | null;
  }) => ({
    lastExecutionEndTime:
      lastExecutionEndTime instanceof Date
        ? getDateTimeString(lastExecutionEndTime)
        : lastExecutionEndTime,
    lastExecutionStartTime:
      lastExecutionStartTime instanceof Date
        ? getDateTimeString(lastExecutionStartTime)
        : lastExecutionStartTime,
    ...rest,
  }),
  apply: (
    previousState,
    {
      appSessionCellId,
      cellId,
      lastExecutionEndTime,
      lastExecutionStartTime,
      state,
    },
  ) => {
    const warnings: string[] = [];

    if (previousState.appSessionCells[appSessionCellId] != null) {
      warnings.push(
        `App session cell previously existed, overwriting: ${appSessionCellId}`,
      );
    }

    previousState.appSessionCells[appSessionCellId] = {
      id: appSessionCellId,
      cellId,
      state: state ?? CellExecutionState.IDLE,
      lastExecutionEndTime: lastExecutionEndTime ?? null,
      lastExecutionStartTime: lastExecutionStartTime ?? null,
    };

    return { warnings };
  },
});
